﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_orderMailSendSucces from './tpl/orderMailSendSucces.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';

import * as Entities_Empty from '../../../lib/entities/empty';
import paymentGateway from '../../../common/helper/paymentGateway';

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_orderMailSendSucces({ model: this.model.toJSON() });
    },
    initialize: function () {
        var self = this;
        this.app = this.options.app;
        
        switch(this.model.attributes.PaymentType) {
            case 0 : this.model.attributes.text = String.format(resources.X100864, this.model.attributes.FirstName, this.model.attributes.DineroInvoiceNumber); break;
            case 1 : this.model.attributes.text = String.format(resources.X100865, this.model.attributes.FirstName, this.model.attributes.DineroInvoiceNumber); break;
        }
    },
    onBeforeShow: function () {
    },
    ui: {
        'orderMailSendSucces_div_paymentGateway' : '#orderMailSendSucces_div_paymentGateway'
    },
    events: {
    },
    //onRender: function () {
    //    var self = this;

    //    var callbackRender = function(html) {
    //        self.ui.orderMailSendSucces_div_paymentGateway.html(html);
    //    }

    //    var callbackGetPaymentGateway = function () {
    //        var modelShopOrder = app.entities.collections.publicShopOrder.fetch({
    //            shopOrder : this.model.ShopOrder,
    //            silent: true,
    //            wait:true,
    //            success: function (mode, response) {
    //                $.when(
    //                    self.app.entities.collections.publicShopProduct.fetch({
    //                        shopOrder : this.model.ShopOrder,
    //                        silent: true,
    //                        wait:true,
    //                        success: function (mode, response) {
    //                        },
    //                        error: function (mode, response) {
    //                        }
    //                    })
    //                ).done(function () {
    //                    if (modelConfigSubscriptionPayment.length > 0) {
    //                        switch (modelConfigSubscriptionPayment[0].attributes.GatewayType) {
    //                            case 1 : paymentGateway.EPay('X100725', self.model.attributes.FirstName, modelShopOrder, self.entities.collections.publicShopProduct, callbackRender); break;
    //                                //case 2 : paymentGateway.Events4us(self.model.attributes.AuthUserId, 'X100725', self.model.attributes.FirstName, modelCustomSubscription, modelCustomSubscriptionJob, callbackRender); break;
    //                        }
    //                    }
    //                });
    //            }
    //        });
    //    }
        
    //    if ((this.model.attributes.RegisterSuccesMessage == 0) || (this.model.attributes.RegisterSuccesMessage == 1)) {
    //        callbackGetPaymentGateway();
    //    }
    //},
    onRender: function () {
        var self = this;

        var callbackRender = function(html) {
            self.ui.orderMailSendSucces_div_paymentGateway.html(html);
        }

        var callbackGetPaymentGateway = function () {
            var modelConfigSubscriptionPayment = self.app.entities.collections.publicConfigSubscriptionPayment.where( { CultureName : self.model.attributes.CultureName, Type : self.model.attributes.PaymentType, GatewayType : self.model.attributes.PaymentGatewayType});

            if ((modelConfigSubscriptionPayment.length > 0) && (modelConfigSubscriptionPayment[0].attributes.Type == 1)) {
                switch (modelConfigSubscriptionPayment[0].attributes.GatewayType) {
                    case 1 : paymentGateway.EPayShop('X100866', self.model.attributes.FirstName, self.model, self.collection, callbackRender); break;
                        //case 2 : paymentGateway.Events4us(self.model.attributes.AuthUserId, 'X100725', self.model.attributes.FirstName, modelCustomSubscription, modelCustomSubscriptionJob, callbackRender); break;
                }
            
            }
        }
        
        callbackGetPaymentGateway();
    },
    onAttach(){
    },
    onDestroy(){
    }
}, Backbone.Radio.Requests);
